import PropTypes from 'prop-types';
import ProviderConnectionConnect from 'Components/Organisms/ProviderConnectionConnect/ProviderConnectionConnect';

export default function ProviderConnectionsConnector(props) {
    const { onConnect, connector, onError, onCancel } = props;

    return (
        <ProviderConnectionConnect
            connector={connector}
            providerConnectionId={null}
            onConnect={onConnect}
            onError={onError}
            onCancel={onCancel}
        />
    );
}

ProviderConnectionsConnector.propTypes = {
    onConnect: PropTypes.func,
    connector: PropTypes.object,
    onError: PropTypes.func,
    onCancel: PropTypes.func,
};
